import { call, put, takeEvery } from 'redux-saga/effects';
import { getLeadProfilePhotos } from '../../requests/lead_profile_photos_request';
import { getLeadProfilePhotosRequestSuccess, getLeadProfilePhotosRequestFailure } from '../actions/lead_profile_photos.actions';
import { GET_LEAD_PROFILE_PHOTOS_REQUEST } from '../constants/lead_profile_photos.constants';
import { message_error } from '../../../../../components/Message';

function* getLeadProfilePhotosSagaRequest({ _id }) {
    const {
        result, msg, options, error,
    } = yield call(getLeadProfilePhotos, _id);
    if (result) {
        yield put(getLeadProfilePhotosRequestSuccess(options.photos));
    } else {
        yield put(getLeadProfilePhotosRequestFailure(error));
        message_error(msg);
    }
}

export default function* getLeadProfilePhotosSaga() {
    yield takeEvery(GET_LEAD_PROFILE_PHOTOS_REQUEST, getLeadProfilePhotosSagaRequest);
}



// WEBPACK FOOTER //
// ./src/modules/Leads/Lead_profile/redux/sagas/get_lead_profile_photos.saga.js